import { domain } from "../../constants/generalConstant";
import { FaCalendarAlt } from "react-icons/fa";
import { HiDocumentCheck } from "react-icons/hi2";
import { IoBusiness } from "react-icons/io5";
import grl from "../../assets/grl.jpg";
import our_service from "../../assets/bus.jpg";
import cargoshipping from "../../assets/box1.jpg";
import sustain from "../../assets/girlshipper.jpg";
import shipatlas from "../../assets/shipatlas.jpg";
import { RiFlightTakeoffLine } from "react-icons/ri";
import { MdOutlineImportExport } from "react-icons/md";
import { CgOptions } from "react-icons/cg";
import { FaTruckFast } from "react-icons/fa6";
import { GiCargoShip } from "react-icons/gi";
import { MdOutlineDirectionsRailway } from "react-icons/md";
import why_choose_us from "../../assets/wapart2.jpg";
import wapart from "../../assets/wapart4.jpg";

// import container from "../../assets/containers.jpg";

export const OneData = [
	{
		title: "Ship Now",
		subTitle: "Find the right service",
		url: "",
		icon: <FaCalendarAlt />,
		id: 1,
	},
	{
		title: "Get a Quote",
		subTitle: "Estimate cost to share and compare",
		url: "",

		icon: <HiDocumentCheck />,
		id: 2,
	},
	{
		title: `${domain} for business`,
		subTitle:
			"Shipping regularly? Request a business account and profit from exclusive benefits",
		url: "",

		icon: <IoBusiness />,
		id: 3,
	},
];

export const twoData = [
	{
		title: "Our Services",
		subTitle: "Fast, Reliable, and Secure Delivery Solutions",
		description: `
        
      Whether you're sending documents, parcels, or large shipments, our comprehensive courier solutions are designed to meet your needs with efficiency and care.
        
        
       
        
        `,
		imgUrl: our_service,
		serviceLink: "",
		serviceLinkTitle: `Explore ${domain} Express`,
		id: 1,
		subData: [
			{
				title: "Flexible Import/Export Options",
				icon: <MdOutlineImportExport />,
				id: 1,
			},
			{
				title: "Tailored Business Solutions",
				icon: <IoBusiness />,
				id: 2,
			},
			{
				title: "Next Possible Business Day",
				icon: <RiFlightTakeoffLine />,
				id: 3,
			},
			{
				title: "Wide Variety of Optional Services",
				icon: <CgOptions />,
				id: 4,
			},
		],
	},
	{
		title: "why choose us?",
		subTitle: "The inside story",
		description: `
        
        Our team is dedicated to providing a seamless courier experience, leveraging cutting-edge technology and a vast network of logistics partners to ensure your packages reach their destination on time, every time.
        
        `,
		imgUrl: why_choose_us,
		serviceLink: "",
		serviceLinkTitle: `Explore ${domain} Global Forwarding`,
		id: 2,
		subData: [
			{
				title: "Fast & Timely",
				icon: <GiCargoShip />,
				id: 1,
			},
			{
				title: "Real-Time Tracking",
				icon: <FaTruckFast />,
				id: 2,
			},
			{
				title: "Secure & Confidential",
				icon: <MdOutlineDirectionsRailway />,
				id: 3,
			},
			{
				title: "Customer-Centric Approach",
				icon: <RiFlightTakeoffLine />,
				id: 4,
			},
			{
				title: "Affordable Pricing",
				icon: <RiFlightTakeoffLine />,
				id: 4,
			},
		],
	},

	{
		title: "Get Started Today",
		subTitle: "",
		description: `
        
Experience hassle-free courier services tailored to your needs. Contact us or request a quote to learn more about our delivery options and how we can help streamline your logistics.

        
        `,
		imgUrl: cargoshipping,
		serviceLink: "",
		serviceLinkTitle: ``,
		id: 2,
		subData: [
			{
				title: "",
				icon: "",
				id: 1,
			},
			{
				title: "",
				icon: "",
				id: 2,
			},
			{
				title: "",
				icon: "",
				id: 3,
			},
			{
				title: "",
				icon: "",
				id: 4,
			},
		],
	},
];

export const thirdData = [
	{
		title: "Sustainability",
		imgUrl: sustain,
		description:
			"Sustainable business begins with sustainable supply chains. We proudly provide a comprehensive portfolio of emission reduced logistics solutions. Find out what we have to offer, why we're committed to sustainability, and how our industry is helping deliver an even better world.",
		id: 1,
	},
	{
		title: `${domain} Trade Atlas 2025`,
		imgUrl: shipatlas,
		description:
			"Global trade recovered in 2024 and is forecast to grow faster over the next five years than during the preceding decade ",
		id: 2,
	},
];
